module.exports = __webpack_public_path__ + "static/img/poster_1.db36d5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/poster_1.jpg
// module id = gzwV
// module chunks = 0